'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import uniqid from 'uniqid';
import Layout from 'Layouts/Front';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import QrCodeSubscription from 'Components/QrCodeSubscription';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import MapIcon from 'Icons/Map';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { action, URL } from 'Shared/Routes';
const {
  app,
  qwest
} = window;
export default class FrontEtablishmentPage extends Component {
  state = {
    loading: true,
    pathname: document.location.pathname,
    desc_expanded: false,
    modal: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      pathname: document.location.pathname
    });
    component.fetchData();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.pathname && prev_props.pathname !== document.location.pathname) {
      component.setState({
        pathname: document.location.pathname
      });
    }
  }
  fetchData = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    let url = document.location.pathname.slice(0, document.location.pathname.indexOf('/formulaire-client'));
    qwest.post(action('getAllFrontEtablishments'), {
      slug: url.slice(url.lastIndexOf('/') + 1),
      striptags: false
    }).then(function (xhr, response) {
      const etablishment = response.data || {};
      etablishment.address = etablishment.address || {};
      let address = [etablishment.address.line_1 || '', ' ', etablishment.address.line_2 || '', ', ', etablishment.address.postal_code || '', ' ', etablishment.address.city || ''].join('');
      let slider_imgs;
      if (etablishment.images?.length > 1) {
        slider_imgs = etablishment.images.map(function (image) {
          let data = {
            alt: image.alt || image.title,
            src: variant({
              img: image,
              size: 1920,
              ratio: '16:9'
            }),
            id: uniqid()
          };
          return data;
        });
      }
      component.setState({
        id: etablishment.id,
        city: etablishment.address.city,
        title: etablishment.name,
        address: address,
        images: etablishment.images,
        slider_imgs: slider_imgs,
        background: etablishment.images?.[0]?.url || undefined,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-transparent']
    }) : undefined;
    const texts = /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__slider-texts"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, state.title), /*#__PURE__*/React.createElement("address", {
      className: "c-front-page-intro__address"
    }, /*#__PURE__*/React.createElement(MapIcon, {
      className: "c-front-page-intro__address-icon"
    }), state.address));
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      meta_title: state.title,
      "hide-header": true,
      "hide-bottom": true
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['etablishment', 'condensed'])
    }, /*#__PURE__*/React.createElement(Image, {
      className: "c-front-page-intro__bg",
      src: state.background,
      alt: 'Illustration ' + state.title
    }), texts, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__filter"
    }), loader), /*#__PURE__*/React.createElement("div", {
      className: "page-container u-flex u-flex-grow-1"
    }, /*#__PURE__*/React.createElement(QrCodeSubscription, {
      etablishment: state.id
    })));
    return output;
  }
}
